import { useEffect, useRef, useState } from "react";

import GuestImg     from "../../assets/images/conversations/ep-16-alisha-sachdev-guest.webp";
import ThumbImg     from "../../assets/images/conversations/016.webp";
import PlayIcon     from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: as2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .as2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .as2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .as2-hero { padding-top: 60px; padding-bottom: 60px; }
  .as2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .as2-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .as2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .as2-hero__title.as2-visible { opacity: 1; transform: translateY(0); }

  /* ── SOCIAL SHARE BUTTONS ── */
  .as2-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .as2-hero__social.as2-visible { opacity: 1; transform: translateY(0); }
  .as2-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .as2-hero__social a:hover { opacity: 0.85; }
  .as2-hero__social a.fb { background: #3B5998; }
  .as2-hero__social a.li { background: #0077B5; }
  .as2-hero__social a.tw { background: #1DA1F2; }
  .as2-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .as2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .as2-hero__spotify.as2-visible { opacity: 1; transform: translateY(0); }
  .as2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .as2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .as2-hero__right.as2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .as2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .as2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .as2-yt-thumb:hover img { opacity: 0.85; }
  .as2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .as2-yt-thumb__play img { width: 40px; height: 44px; }
  .as2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .as2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .as2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .as2-body.as2-visible { opacity: 1; transform: translateY(0); }
  .as2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .as2-body__para:last-child { margin-bottom: 0; }
  .as2-body__link {
    color: #E2E2E2;
    text-decoration: underline;
    word-break: break-all;
  }
  .as2-body__link:hover { opacity: 0.8; }

  /* ── GUEST ── */
  .as2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .as2-guest.as2-visible { opacity: 1; transform: translateY(0); }
  .as2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .as2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .as2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .as2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .as2-inner { padding-left: 32px; padding-right: 32px; }
    .as2-hero { padding-top: 32px; padding-bottom: 48px; }
    .as2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .as2-hero__title { font-size: 24px; }
    .as2-hero__left { gap: 16px; }
    .as2-hero__social { gap: 10px; }
    .as2-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .as2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .as2-guest__photo-bg { width: 260px; height: 300px; }
    .as2-guest__name { font-size: 24px; margin-top: 18px; }
    .as2-body__para { font-size: 14px; margin-bottom: 12px; }
    .as2-body { padding-bottom: 48px; }
    .as2-guest { padding-bottom: 48px; }
    .as2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .as2-inner { padding-left: 16px; padding-right: 16px; }
    .as2-hero { padding-top: 51px; padding-bottom: 30px; }
    .as2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .as2-hero__left { gap: 30px; }
    .as2-hero__title { font-size: 30px; }
    .as2-hero__social { gap: 11px; }
    .as2-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .as2-body__para { font-size: 16px; margin-bottom: 10px; }
    .as2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .as2-guest__photo-bg { width: 100%; height: 386px; }
    .as2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .as2-body { padding-bottom: 30px; }
    .as2-guest { padding-bottom: 30px; }
    .as2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("as2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP16_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="as2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 16 Alisha Sachdev CNBC TV18"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="as2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 16 Alisha Sachdev thumbnail" />
      <div className="as2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="as2-hero">
      <div className="as2-inner">
        <div className="as2-hero__grid">
          <div className="as2-hero__left">
            <div ref={titleRef} className="as2-hero__title">
              EP 16 | Does China control the Indian E Mobility Sector? | Alisha Sachdev | CNBC TV 18
            </div>
            <div ref={socialRef} className="as2-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="as2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/7xS9Ecaa5r4ZrV95mS54he?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 16 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="as2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="as2-body">
      <div className="as2-inner">
        <p className="as2-body__para">
          Our program has now been running for twelve months now, and we have covered a host of subjects including battery chemistries, the potential for Giga-factories in India, charging standards, government policies, mobility technologies and the challenges for the ChargePoint operators.
        </p>
        <p className="as2-body__para">
          In this episode we have a freewheeling discussion on a range of subjects including whether China controls the Indian EV sector with a tight fist and the role of media in facilitating faster adoption of E Mobility in India. This was a fun episode as we talked to Alisha Sachdev, a journalist and TV anchor with CNBC TV-18. Alisha was a former news anchor with NDTV and writes for the business pages of The Hindustan Times. She is one of India's preeminent media experts covering the auto sector, given that she has interviewed almost every business and every CEO in this industry. Enjoy!
        </p>
        <p className="as2-body__para">
          Listen to our other episodes with key industry leaders on how we can accelerate the adoption of EVs in India:{" "}
          <a
            className="as2-body__link"
            href="https://energizingindia.tv/episodes/"
            target="_blank"
            rel="noreferrer"
          >
            https://energizingindia.tv/episodes/
          </a>
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="as2-guest">
      <div className="as2-inner">
        <h2 className="as2-guest__title">Our Guest</h2>
        <div>
          <div className="as2-guest__photo-bg">
            <img src={GuestImg} alt="Alisha Sachdev" />
          </div>
          <p className="as2-guest__name">Alisha SACHDEV</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep16AlishaSachdev() {
  return (
    <>
      <style>{CSS}</style>
      <div className="as2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}